/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Showronapopup2Inputs */

const en_entity_showronapopup2 = /** @type {(inputs: Entity_Showronapopup2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show RONA Popup`)
};

const de_entity_showronapopup2 = /** @type {(inputs: Entity_Showronapopup2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RONA-Popup anzeigen`)
};

/**
* | output |
* | --- |
* | "Show RONA Popup" |
*
* @param {Entity_Showronapopup2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_showronapopup2 = /** @type {((inputs?: Entity_Showronapopup2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Showronapopup2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_showronapopup2(inputs)
	return de_entity_showronapopup2(inputs)
});
export { entity_showronapopup2 as "entity_showRonaPopup" }